import { useTheme } from "@mui/material/styles";
import { Text } from "@src/appV2/redesign/components/Text";
import { useIsRebrand } from "@src/appV2/redesign/theme/RebrandProvider";

import { useDisplayTime } from "./useDisplayTime";

export interface LocalTimeProps {
  timeZone?: string;
  /**
   * Text color override. Defaults to the navbar content color (rebrand) or
   * white (pre-rebrand) — preserved so the admin header keeps its original
   * look. Surfaces outside the navbar (sidebars, cards) should pass a color
   * that fits their background.
   */
  color?: string;
}

export function LocalTime(props: LocalTimeProps) {
  const { timeZone, color } = props;
  const localTime = useDisplayTime({ timeZone });
  const isRebrand = useIsRebrand();
  const theme = useTheme();
  const effectiveColor =
    color ?? (isRebrand ? theme.palette.navbar?.itemContent : theme.palette.common.white);

  return (
    <Text variant="body2" sx={{ color: effectiveColor }}>
      Local time: {localTime}
      {timeZone ? ` (${timeZone}) ` : null}
    </Text>
  );
}
